import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Text } from '../../../../ui'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import iconoEnlace from '../../../../../../assets/iconos/iconEnlace.png'
import clsx from 'clsx'
import React, { useContext, useEffect, useState } from 'react'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { formatCurrency } from '../../../../../utils/formatter'
import ModalConciliacionRemuneracion from './ModalConciliar/ModalConciliacionRemuneracion'
import SubTableRRHH from './SubTableRRHH'
import GlobalContext from '../../../../../../context/global-context'
import { OrganizationAPI } from '../../../../../../api/organization.api'
import ModalCentroCosto from './ModalCentroCosto/ModalCentroCosto'
import ModalViewAdministracion from '../../../../ui/tables/baseTable/ModalViewAdministracion'
import { Dialog, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { BusinessAPI } from '../../../../../../api/business.api'
import { sileo } from 'sileo'
import { canDeleteRemuneration } from '../../../../../utils/remunerationDeletion'

const DELETE_BLOCKED_MESSAGE = 'No puedes eliminar esta remuneración porque tiene movimientos conciliados. Para eliminarla, primero debes desconciliar los movimientos.'

const TableRemuneracion = ({rows, allRows = rows, rowsPerPage, onSort, order, setSwitchGetData }) => {
  //const [page] = useState(0)
  const [deleteBlocked, setDeleteBlocked] = useState(false)
  const [comprobanteRow, setComprobanteRow] = useState(null)
  const [openEdit, setOpenEdit] = useState(false)
  const [openCentro, setOpenCentro] = useState(false)
  const [mesExpandido, setMesExpandido] = useState(null)
  const [tipoLibro, setTipoLibro] = useState(null)
  const [idLibro, setIdLibro] = useState()
  const [deletingGroup, setDeletingGroup] = useState(null)
  const [, setData] = useState([])
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClick = (idLibro, tipo) => {
    setIdLibro(idLibro)
    setTipoLibro(tipo)
    setOpenEdit(true)
  }

  const handleClickCentro = (idLibro, tipo) => {
    setIdLibro(idLibro)
    setTipoLibro(tipo)
    setOpenCentro(true)
  }

  const handleDelete = async (grupo) => {
    if (deletingGroup != null) return
    if (!canDeleteRemuneration(allRows.filter(item => item.query === grupo.query))) {
      setDeleteBlocked(true)
      return
    }

    try {
      // Buscar el primer registro dentro del grupo que tenga un idLibro válido
      const rowConId = grupo.data.find(item => item.idLibro);
      if (!rowConId) {
        console.error("No se encontró un idLibro válido en el grupo.");
        return;
      }
      setDeletingGroup(grupo.query)
      const { data: latestRows } = await new BusinessAPI().getListWorker({
        businessId: currentBusiness.id,
        queryFrom: grupo.query,
        queryTo: grupo.query
      })
      const latestGroup = Array.isArray(latestRows)
        ? latestRows.filter(item => item.query === grupo.query)
        : []
      if (!canDeleteRemuneration(latestGroup)) {
        setDeleteBlocked(true)
        setSwitchGetData(true)
        return
      }
      await organizationAPI.deleteRemuneracion(
        currentBusiness.id, 
        rowConId.idLibro, 
        'remuneracion'
      );
      // Filtramos los datos eliminando los que pertenecen a ese idLibro
      setData(prev => prev.filter(item => item.idLibro !== rowConId.idLibro));
      setSwitchGetData(true);
    } catch (error) {
      console.error("Error al eliminar:", error);
      sileo.error({ title: 'No se pudo eliminar', description: 'No fue posible verificar o eliminar el movimiento. Actualiza la tabla e inténtalo nuevamente.' })
    } finally {
      setDeletingGroup(null)
    }
  };
 /* const handleDelete = async (rows) => {
    try {
      await organizationAPI.deleteRemuneracion(currentBusiness.id, rows.idLibro, 'remuneracion');
      setData(prev => prev.filter(item => item.idLibro !== rows.idLibro));
      setSwitchGetData(true)
    } catch (error) {
      console.error("Error al eliminar:", error);
    } finally {
      //setLoading(false);
    }
  };*/

  //const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0
  const styles = {
    table: 'w-full min-w-[760px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 sm:px-2 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-200 hover:bg-gray-100/50',
    td: 'py-2 px-1 sm:px-2 w-auto max-w-[200px] text-center break-words align-top',
    smallCol: 'w-auto max-w-[60px] sm:max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem]',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-500',
  }

  const normalizeStatus = status =>
    String(status || '')
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s*UNDEFINED\s*/g, ' ')
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()

  const getStatusKey = status => {
    const normalized = normalizeStatus(status)
    if (!normalized) return 'OTHER'
    if (normalized.includes('PARCIALMENTE PAGADO')) return 'PARCIALMENTE_PAGADO'
    if (normalized.includes('POR PAG')) return 'POR_PAGAR'
    if (normalized.includes('PAGADO')) return 'PAGADO'
    return 'OTHER'
  }

  const isPaidStatus = status => getStatusKey(status) === 'PAGADO'

  const getStatusLabel = status => {
    const key = getStatusKey(status)
    if (key === 'POR_PAGAR') return 'POR PAGAR'
    if (key === 'PAGADO') return 'PAGADO'
    if (key === 'PARCIALMENTE_PAGADO') return 'PARCIALMENTE PAGADO'
    const normalized = normalizeStatus(status)
    return normalized || '—'
  }

  const statusBadgeClass = status => {
    const key = getStatusKey(status)
    return clsx(
      'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.55rem] sm:text-[0.6rem] font-semibold uppercase tracking-wider leading-tight',
      {
        'text-danger bg-danger/10': key === 'POR_PAGAR',
        'text-success bg-success/10': key === 'PAGADO',
        'text-amber-700 bg-amber-100': key === 'PARCIALMENTE_PAGADO'
      }
    )
  }

  const orderableCols = [
    { col: 'Periodo', field: 'numeroFolio' },
    { col: 'Monto', field: 'montoTotal' },
    { col: 'Status', field: 'status' },
    { col: 'Acciones', field: 'aprobado' },
    { col: null, field: null },
  ]

  const agruparPorQuery = (rows) => {
    const meses = {
      '01': 'Enero', '02': 'Febrero', '03': 'Marzo', '04': 'Abril',
      '05': 'Mayo', '06': 'Junio', '07': 'Julio', '08': 'Agosto',
      '09': 'Septiembre', '10': 'Octubre', '11': 'Noviembre', '12': 'Diciembre'
    };

    const agrupados = {};

    rows.forEach(row => {
      const query = row.query;
      if (!agrupados[query]) agrupados[query] = [];
      agrupados[query].push(row);
    });

    const resultado = Object.entries(agrupados).map(([query, grupo]) => {
      const [mes, anio] = query.split('-');
      const liquidosUnicos = [...new Set(grupo.map(item => item.totalLiquido || 0))];
      const previredsUnicos = [...new Set(grupo.map(item => item.totalPrevired || 0))];
      return {
        query,
        mes,
        anio,
        mesNombre: `${meses[mes]} ${anio}`,
        totalLiquido: liquidosUnicos.reduce((a, b) => a + b, 0),
        totalPrevired: previredsUnicos.reduce((a, b) => a + b, 0),
        idLibro: grupo[0]?.idLibro,
        idLiquido: grupo[0]?.idLiquido,
        idPrevired: grupo[0]?.idPrevired,
        data: grupo,
        status: grupo[0]?.status,
        statusPrevired: grupo[0]?.statusPrevired,
      };
    });

    resultado.sort((a, b) => {
      if (a.anio !== b.anio) return a.anio - b.anio;
      return a.mes - b.mes;
    });

    return resultado;
  };

  const grupos = agruparPorQuery(rows)

  const renderComprobantes = grupo => {
    const comprobantes = [...new Map(grupo.data
      .filter(row => row.comprobante && row.idLibro)
      .map(row => [row.idLibro, row])).values()]

    return comprobantes.map(row => (
      <div key={row.idLibro} className='mt-1'>
        <button
          type='button'
          className='text-accent2 underline text-xs cursor-pointer'
          aria-label={`Abrir comprobante ${row.comprobante}`}
          onClick={() => setComprobanteRow(row)}
        >
          {row.comprobante}
        </button>
      </div>
    ))
  }

  const comprobanteModal = comprobanteRow && (
    <ModalViewAdministracion
      openModal={Boolean(comprobanteRow)}
      setOpenModal={value => {
        if (!value) setComprobanteRow(null)
      }}
      comprobanteId={comprobanteRow.idLibro}
      validation={1}
      folio={comprobanteRow.nombreFolio}
      numeroFolio={comprobanteRow.folio}
    />
  )

   useEffect(() => {
    if (grupos.length > 0) {
      setMesExpandido(grupos[0].query); // expandir el primer grupo
    }
  }, [rows])

  const deleteBlockedModal = (
    <Dialog open={deleteBlocked} onClose={() => setDeleteBlocked(false)}
      aria-labelledby='remuneration-delete-blocked-title'
      aria-describedby='remuneration-delete-blocked-description'
      maxWidth='sm' fullWidth
      PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}>
      <div className='flex items-center justify-end bg-primary px-4 py-3'>
        <button
          type='button'
          onClick={() => setDeleteBlocked(false)}
          className='flex h-7 w-7 items-center justify-center rounded-full text-white transition-colors hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white'
          aria-label='Cerrar aviso'
        >
          <span aria-hidden='true'>✕</span>
        </button>
      </div>
      <div className='flex min-h-[220px] flex-col items-center justify-center bg-surface px-6 py-7 font-sans sm:px-8'>
        <h2 id='remuneration-delete-blocked-title' className='mb-4 text-center text-xl font-medium text-text'>
          No se puede eliminar la remuneración
        </h2>
        <div aria-hidden='true' className='mb-4 flex h-9 w-9 items-center justify-center rounded-full border border-text text-lg text-text'>!</div>
        <p id='remuneration-delete-blocked-description' className='text-center text-sm leading-relaxed text-muted'>
          {DELETE_BLOCKED_MESSAGE}
        </p>
      </div>
      <div className='flex justify-end border-t border-border bg-bg px-6 py-4'>
        <button
          type='button'
          onClick={() => setDeleteBlocked(false)}
          autoFocus
          className='rounded-full bg-primary px-6 py-2 font-sans text-sm text-white transition-colors hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'
        >
          Volver
        </button>
      </div>
    </Dialog>
  )

  if (isMobile) {
    return (
      <div className='space-y-3 font-sans'>
        {deleteBlockedModal}
        {comprobanteModal}
        {grupos.map(grupo => {
          const isExpanded = mesExpandido === grupo.query
          return (
            <div key={grupo.query} className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
              <div className='flex items-start justify-between gap-2'>
                <div>
                  <Text className='text-xs font-bold'>Remuneraciones</Text>
                  <Text className='text-[11px] text-gray-500'>{grupo.mesNombre}</Text>
                  {renderComprobantes(grupo)}
                </div>
                <button
                  type='button'
                  className='flex items-center justify-center w-8 h-8 rounded-full bg-gray-100'
                  onClick={() => setMesExpandido(isExpanded ? null : grupo.query)}
                  aria-label={isExpanded ? 'Ocultar detalle' : 'Ver detalle'}
                >
                  <KeyboardArrowDownIcon
                    className={clsx('transition-transform', { 'rotate-180': isExpanded })}
                  />
                </button>
              </div>

              <div className='mt-3 space-y-3'>
                <div className='rounded-xl bg-gray-50 p-3'>
                  <div className='flex items-start justify-between gap-2'>
                    <div>
                      <Text className='text-[10px] text-gray-400'>Monto Líquido</Text>
                      <Text className='text-sm font-semibold'>{formatCurrency(grupo.totalLiquido)}</Text>
                    </div>
                    <Text className={statusBadgeClass(grupo.status)}>
                      {getStatusLabel(grupo.status)}
                    </Text>
                  </div>
                  <div className='mt-2 flex items-center justify-between gap-2'>
                    <div className='flex items-center gap-2'>
                      <button
                        type='button'
                        className='flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 bg-white'
                        onClick={() => handleClickCentro(grupo.idPrevired, 'liquido')}
                        aria-label='Editar monto líquido'
                      >
                        <EditOutlinedIcon sx={{ fontSize: 16, color: 'inherit' }} />
                      </button>
                      <button
                        type='button'
                        className={clsx(
                          'flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 bg-white',
                          {
                            'bg-accent2 text-white border-transparent': isPaidStatus(grupo.status)
                          }
                        )}
                        onClick={() => handleClick(grupo.idLiquido, 'liquido')}
                        aria-label='Conciliar monto líquido'
                      >
                        <img
                          src={iconoEnlace}
                          alt='icono enlace'
                          className={clsx('w-6 h-6 transition-all duration-300', {
                            'brightness-200': isPaidStatus(grupo.status)
                          })}
                        />
                      </button>
                    </div>
                    <Text className='text-[11px] text-gray-500'>
                      {isPaidStatus(grupo.status) ? 'Conciliado' : 'Conciliar'}
                    </Text>
                  </div>
                </div>

                <div className='rounded-xl bg-gray-50 p-3'>
                  <div className='flex items-start justify-between gap-2'>
                    <div>
                      <Text className='text-[10px] text-gray-400'>Previred</Text>
                      <Text className='text-sm font-semibold'>{formatCurrency(grupo.totalPrevired)}</Text>
                    </div>
                    <Text className={statusBadgeClass(grupo.statusPrevired)}>
                      {getStatusLabel(grupo.statusPrevired)}
                    </Text>
                  </div>
                  <div className='mt-2 flex items-center justify-between gap-2'>
                    <div className='flex items-center gap-2'>
                      <button
                        type='button'
                        className='flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 bg-white'
                        onClick={() => handleClickCentro(grupo.idPrevired, 'previred')}
                        aria-label='Editar previred'
                      >
                        <EditOutlinedIcon sx={{ fontSize: 16, color: 'inherit' }} />
                      </button>
                      <button
                        type='button'
                        className={clsx(
                          'flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 bg-white',
                          {
                            'bg-accent2 text-white border-transparent': isPaidStatus(grupo.statusPrevired)
                          }
                        )}
                        onClick={() => handleClick(grupo.idPrevired, 'previred')}
                        aria-label='Conciliar previred'
                      >
                        <img
                          src={iconoEnlace}
                          alt='icono enlace'
                          className={clsx('w-6 h-6 transition-all duration-300', {
                            'brightness-200': isPaidStatus(grupo.statusPrevired)
                          })}
                        />
                      </button>
                    </div>
                    <Text className='text-[11px] text-gray-500'>
                      {isPaidStatus(grupo.statusPrevired) ? 'Conciliado' : 'Conciliar'}
                    </Text>
                  </div>
                </div>
              </div>

              <div className='mt-3 flex items-center justify-between'>
                <button
                  type='button'
                  disabled={deletingGroup != null}
                  className='flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 bg-white text-slate-400 disabled:cursor-not-allowed disabled:opacity-60'
                  onClick={() => handleDelete(grupo)}
                  aria-label='Eliminar remuneración'
                >
                  {deletingGroup === grupo.query ? (
                    <span className='h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent' />
                  ) : (
                    <HighlightOffIcon sx={{ color: 'inherit' }} />
                  )}
                </button>
                <Text className='text-[11px] text-gray-500'>
                  {deletingGroup === grupo.query ? 'Eliminando...' : 'Eliminar'}
                </Text>
              </div>

              {isExpanded && (
                <div className='mt-3'>
                  <SubTableRRHH data={grupo.data} />
                </div>
              )}
            </div>
          )
        })}
        {openEdit && (
          <ModalConciliacionRemuneracion open={openEdit} setOpen={setOpenEdit} idLibro={idLibro} tipoLibro={tipoLibro} setSwitchGetData={setSwitchGetData}/>
        )}
        {openCentro && (
          <ModalCentroCosto open={openCentro} setOpen={setOpenCentro} idLibro={idLibro} tipoLibro={tipoLibro} setSwitchGetData={setSwitchGetData}/>
        )}
      </div>
    )
  }

  return (
    <div className='overflow-x-auto'>
      {deleteBlockedModal}
      {comprobanteModal}
      <div className='h-full mt-2'>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              {orderableCols.map(({ col, field }, i) => (
                <th key={i} 
                className={clsx(
                  styles.th,
                  { 'cursor-pointer': field },
                  i === 0 && styles.smallCol
                )}
                onClick={() => field && onSort({ col, field })}>
                {col}
                {order.col === col && (
                  <KeyboardArrowDownIcon
                    className={clsx('transition-all ml-2 cursor-pointer', {
                      'opacity-40': order.col !== col,
                      'rotate-180': order.direction === 'desc'
                    })}
                  />
                )}
              </th>
              ))}
            </tr>
          </thead>
          <tbody className={styles.tbody}>
            {grupos.map((grupo, idx) => (
              <React.Fragment key={grupo.query}>
                {/* Fila 1: Total Haberes */}
                <tr className='bg-gray-100' >
                  <td rowSpan={2} className={`${styles.td} text-center align-middle`}>
                    <div className="flex flex-col items-center justify-center">
                      {/* Fila superior: título + botón */}
                      <div className="flex items-center justify-center space-x-2">
                        <Text className={`${styles.boldText} items-center justify-center mt-1`}>Remuneraciones</Text>
                        <div
                          className="flex px-0.5 py-0.5 bg-gray-200 rounded hover:bg-gray-300 cursor-pointer"
                          onClick={() =>
                            setMesExpandido(mesExpandido === grupo.query ? null : grupo.query)
                          }
                        >
                          <KeyboardArrowDownIcon sx={{ fontSize: 16, color: 'inherit' }} />
                        </div>
                      </div>

                      {/* Fila inferior: mesNombre */}
                      <Text className={`${styles.boldText} items-center justify-center mt-1`}>{grupo.mesNombre}</Text>
                      {renderComprobantes(grupo)}
                    </div>
                  </td>
                  <td className={`${styles.td} text-center`}>
                    <div className="flex flex-row items-center justify-center gap-2 mt-4">
                      <Text className={styles.boldText}>
                        Monto Líquido: {formatCurrency(grupo.totalLiquido)}
                      </Text>
                      <div
                        className="flex px-0.5 py-0.5 bg-gray-200 rounded hover:bg-gray-300 cursor-pointer"
                        onClick={() => handleClickCentro(grupo.idPrevired, 'liquido')}
                      >
                        <EditOutlinedIcon sx={{ fontSize: 16, color: 'inherit' }} />
                      </div>
                    </div>
                  </td>
                  <td className={styles.td}>
                    <div className="flex flex-col items-center justify-center mt-4">
                      <Text className={statusBadgeClass(grupo.status)}>
                        {getStatusLabel(grupo.status)}
                      </Text>
                    </div>
                  </td>
                  {/* Acciones: Conciliar + Eliminar */}
                  <td className={styles.td}>
                    <div className='flex flex-col text-xs items-center justify-center hover:cursor-pointer'>
                      <div
                        className={clsx(
                          'flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 hover:bg-slate-100/50 transition-colors duration-150',
                          {
                            'bg-accent2 text-white': isPaidStatus(grupo.status),
                            'bg-[#fff]': !isPaidStatus(grupo.status),
                          }
                        )}
                        onClick={() => handleClick(grupo.idLiquido, 'liquido')}
                      >
                        <img
                          src={iconoEnlace}
                          alt="icono enlace"
                          className={clsx('w-6 h-6 transition-all duration-300', {
                            'brightness-200': isPaidStatus(grupo.status),
                          })}
                        />
                      </div>
                      <Text className='mt-1'>
                        {isPaidStatus(grupo.status) ? 'Conciliado' : 'Conciliar'}
                      </Text>
                    </div>
                  </td>

                  {/* Botón Eliminar único para ambas filas */}
                  <td rowSpan={2} className={`${styles.td, styles.smallCol} text-center align-middle mr-6`}>
                    <div className='flex flex-col text-xs items-center justify-center'>
                      <button
                        type='button'
                        disabled={deletingGroup != null}
                        aria-label='Eliminar remuneración'
                        className={clsx(
                          'bg-[#fff] flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 transition-colors duration-150',
                          deletingGroup != null
                            ? 'cursor-not-allowed opacity-60'
                            : 'hover:bg-slate-100/50 cursor-pointer'
                        )}
                        onClick={() => handleDelete(grupo)}
                      >
                        {deletingGroup === grupo.query ? (
                          <span className='h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent' />
                        ) : (
                          <HighlightOffIcon sx={{ color: 'inherit' }} />
                        )}
                      </button>
                      <Text className='mt-1'>
                        {deletingGroup === grupo.query ? 'Eliminando...' : 'Eliminar'}
                      </Text>
                    </div>
                  </td>
                </tr>

                {/* Fila 2: Monto Líquido */}
                <tr className='bg-gray-100 border-b border-gray-300'>
                  <td className={styles.td}>
                    <div className="flex flex-row items-center justify-center gap-2 mt-4">
                      <Text className={styles.boldText}> Previred: {formatCurrency(grupo.totalPrevired)}</Text>
                      <div
                        className="flex px-0.5 py-0.5 bg-gray-200 rounded hover:bg-gray-300 cursor-pointer"
                        onClick={() => handleClickCentro(grupo.idPrevired, 'previred')}
                      >
                        <EditOutlinedIcon sx={{ fontSize: 16, color: 'inherit' }} />
                      </div>
                  </div>
                  </td>
                  <td className={styles.td}>
                    <div className="flex flex-col items-center justify-center mt-4">
                      <Text className={statusBadgeClass(grupo.statusPrevired)}>
                        {getStatusLabel(grupo.statusPrevired)}
                      </Text>
                    </div>
                  </td>
                  {/* Acciones: Solo botón Conciliar */}
                  <td className={styles.td}>
                    <div className='flex flex-col text-xs items-center justify-center hover:cursor-pointer'>
                      <div
                        className={clsx(
                          'flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 hover:bg-slate-100/50 transition-colors duration-150',
                          {
                            'bg-accent2 text-white': isPaidStatus(grupo.statusPrevired),
                            'bg-[#fff]': !isPaidStatus(grupo.statusPrevired),
                          }
                        )}
                        onClick={() => handleClick(grupo.idPrevired, 'previred')}
                      >
                        <img
                          src={iconoEnlace}
                          alt="icono enlace"
                          className={clsx('w-6 h-6 transition-all duration-300', {
                            'brightness-200': isPaidStatus(grupo.statusPrevired),
                          })}
                        />
                      </div>
                      <Text className='mt-1'>
                        {isPaidStatus(grupo.statusPrevired) ? 'Conciliado' : 'Conciliar'}
                      </Text>
                    </div>
                  </td>
                </tr>
                
                {mesExpandido === grupo.query && (
                  <tr>
                    <td colSpan={8} className='bg-white'>
                      <SubTableRRHH data={grupo.data} />
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {openEdit && (
        <ModalConciliacionRemuneracion open={openEdit} setOpen={setOpenEdit} idLibro={idLibro} tipoLibro={tipoLibro} setSwitchGetData={setSwitchGetData}/>
      )}
      {openCentro && (
        <ModalCentroCosto open={openCentro} setOpen={setOpenCentro} idLibro={idLibro} tipoLibro={tipoLibro} setSwitchGetData={setSwitchGetData}/>
      )}
    </div>
  )
}

export default TableRemuneracion
